export const nodeType = "AUDIO_EFFECT_DELAY";
